import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { ModelAccountFromToken } from '../../models/authentication/account-from-token.model';
import { AbstractEndpoints } from '../../services/endpoints/endpoints.service.abstract';
import { AbstractAppAuthentication } from '../authentication/authentication.app.abstract';
import { ModelOrganization } from '../../models/organizations/organization.model';

export class MockAppAuthentication implements AbstractAppAuthentication {


    private storageForAccountName = 'mock_data_account';
    get account(): ModelAccountFromToken | undefined {
        const token = localStorage.getItem(this.storageForAccountName);
        return token ? (JSON.parse(token) as ModelAccountFromToken) : undefined;
    }
    public isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private httpClient: HttpClient, private endpoints: AbstractEndpoints) {
        this.registerForAuthenticationEvents();
    }

    private _selectedOrganization: ModelOrganization | undefined = undefined;
    get selectedOrganization(): ModelOrganization | undefined {
        if (!this.account) {
            return undefined;
        } else if (!this._selectedOrganization) {
            this._selectedOrganization = this.account.idTokenClaims.organizations[0];
        }
        return this._selectedOrganization;
    }
    set selectedOrganization(value: ModelOrganization | undefined) {
        this._selectedOrganization = value;
    }

    handleRedirectObservable(): void {
        // No need to handle redirects
    }

    registerForAuthenticationEvents(): void {
        this.setLoginAuthority();
    }

    setRegisterAuthority(): void {
        this.httpClient.get<ModelAccountFromToken[]>(`${this.endpoints.authorization.signup}?mockId=new`).subscribe(user => {
            localStorage.setItem(this.storageForAccountName, JSON.stringify(user[0]));
        });

    }

    setLoginAuthority(): void {
        this.httpClient.get<ModelAccountFromToken[]>(`${this.endpoints.authorization.login}?mockId=existing`).subscribe(user => {
            localStorage.setItem(this.storageForAccountName, JSON.stringify(user[0]));
        });
    }

    logout(): void {
        this.isLoggedIn.next(false);
    }
}
